package pl.decks.chartjs.radar.dataset

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.model.JSScriptable
import pl.decks.chartjs.style.BorderCapStyle
import pl.decks.chartjs.style.BorderJoinStyle
import pl.decks.chartjs.value.FillValue

data class LineProperties(
    val backgroundColor: JSScriptable<ChartColor>,
    val borderColor: JSScriptable<ChartColor>,
    val borderWidth: JSScriptable<Int>,
    val borderCapStyle: JSScriptable<BorderCapStyle>,
    val borderJoinStyle: JSScriptable<BorderJoinStyle>,
    val borderDash: JSScriptable<List<Int>>,
    val borderDashOffset: JSScriptable<Float>,
    val fill: JSScriptable<FillValue>,
    val tension: Float = 0f,
    val spanGaps: Boolean? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.backgroundColor = backgroundColor.toChartJs { it.toChartJs() }
        this.borderColor = borderColor.toChartJs { it.toChartJs() }
        this.borderWidth = borderWidth.toChartJs { it.asDynamic() }
        this.borderCapStyle = borderCapStyle.toChartJs { it.toChartJs() }
        this.borderJoinStyle = borderJoinStyle.toChartJs { it.toChartJs() }
        this.borderDash = borderDash.toChartJs { it.toTypedArray().asDynamic() }
        this.borderDashOffset = borderDashOffset.toChartJs { it.asDynamic() }
        this.fill = fill.toChartJs { it.toChartJs() }
        this.tension = tension.asDynamic()
        if (spanGaps != null) this.spanGaps = spanGaps.asDynamic()
    }
}
